import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./style.css";
import config from "../../config/config.js";

export const ViewWrapper = () => {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchNews = async () => {
            try {
                const response = await fetch(`${config.apiUrl2}/api/news/tri`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "User-Agent": "insomnia/11.3.0",
                    }
                });

                if (!response.ok) {
                    throw new Error("Ошибка загрузки новостей");
                }

                const data = await response.json();
                setNews(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchNews();
    }, []);

    const goToNewsPage = () => {
        navigate("/news-pages");
    };

    if (loading) return <div className="view-wrapper">Загрузка...</div>;
    if (error) return <div className="view-wrapper">Ошибка: {error}</div>;

    return (
        <div className="view-wrapper">
            <h2 className="promo-title">НОВОСТИ</h2>

            <div className="news-cards">
                {news.map((item) => (
                    <div key={item.id} className="news-carddd1">
                        <img
                            className="news-image"
                            src={
                                item.imageUrl
                                    ? item.imageUrl
                                    : `${config.apiUrl2}/api/news/images/${item.filename}`
                            }
                            // alt="Новость"
                            // onError={(e) => {
                            //     e.target.src = "/no-image.png"; // fallback если файл не найден
                            // }}
                        />

                        <div className="news-date">
                            {new Date(item.newsDate).toLocaleDateString("ru-RU")}
                        </div>
                        <p className="news-text">
                            {item.newsContent
                                ? (item.newsContent.length > 50
                                        ? item.newsContent.slice(0, 50) + "..."
                                        : item.newsContent.slice(0, 50)
                                )
                                    .match(/.{1,35}/g) // разбивает на строки по 35 символов
                                    .join("\n")
                                : ""}
                        </p>

                    </div>
                ))}
            </div>

            <div className="cta-container">
                <button className="cta-button" onClick={goToNewsPage}>
                    ДРУГИЕ НОВОСТИ
                </button>
            </div>
        </div>
    );
};
